export type MetricTabName = "overview" | "engagement";

export type BenchmarkTabName = MetricTabName | "channels";

export enum BenchmarkControllers {
    overview = "overview",
    engagement = "engagement",
}

export enum BenchmarkTabs {
    overview,
    engagement,
}

type TabConfigEntity = Record<BenchmarkTabName, { id: BenchmarkTabName; title: string; isDisabled?: boolean }>;

export const TAB_DICTIONARY: TabConfigEntity = {
    overview: { id: "overview", title: "bt.report.tabs.overview.text" },
    engagement: { id: "engagement", title: "bt.report.tabs.engagement.text" },
    channels: { id: "channels", title: "bt.report.tabs.channels.text" },
} as const;
